var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationContract(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M62 18h-9V9h2v7h7v2",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M63 42h-2V17.414L53.586 10H19v32h-2V8h37.414L63 16.586V42M63 72H17V54h2v16h42V58h2v14",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M18 52h48v-2H18zM18 46h48v-2H18z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 50h3v-4h-3v4zm-2 2h7v-8h-7v8zM14.277 50H17v-4h-2.723l-3.333 2 3.333 2zM18 52h-4a.997.997 0 01-.515-.143l-5-3a.997.997 0 010-1.714l5-3A.997.997 0 0114 44h4a1 1 0 011 1v6a1 1 0 01-1 1zM63 56H47v-2h14v-3h2v5M43 62c-1.416 0-2.162-.747-2.708-1.293-.489-.49-.729-.707-1.292-.707-.563 0-.803.217-1.293.707C37.162 61.253 36.415 62 35 62c-1.414 0-2.161-.747-2.707-1.293-.491-.49-.731-.707-1.293-.707-.562 0-.802.217-1.294.707C29.161 61.253 28.413 62 27 62s-2.161-.747-2.706-1.293C23.802 60.217 23.561 60 23 60v-2c1.413 0 2.161.747 2.706 1.293.492.49.732.707 1.294.707.561 0 .802-.217 1.293-.707C28.839 58.747 29.587 58 31 58c1.414 0 2.161.747 2.707 1.293.491.49.731.707 1.293.707.563 0 .803-.217 1.292-.707C36.838 58.747 37.584 58 39 58c1.415 0 2.162.747 2.707 1.293.49.49.73.707 1.293.707v2",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M23 18h2v-2h-2zM27 18h2v-2h-2zM31 18h2v-2h-2zM23 24h34v-2H23zM23 28h34v-2H23zM23 32h34v-2H23zM23 36h34v-2H23zM23 40h16v-2H23zM23 66h20v-2H23z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationContract;